document.addEventListener("DOMContentLoaded", () => {

    const partnerAgreementUrlLink = document.querySelector(".js-open-partner-agreement-url");

    if(partnerAgreementUrlLink) {
        partnerAgreementUrlLink.addEventListener("click", () => {
            const _partnerAgreementUrl = document.querySelector("#partner_agreement_url").value;

            if(_partnerAgreementUrl && _partnerAgreementUrl.toString()
            .match(
                /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
            )) {
                window.open(_partnerAgreementUrl, "_blank");
            }
        })
    }

})